import { useHistory } from 'react-router';
import { useOnMount } from "./useOnMount";
import { useStoreActions, useStoreStatic } from "../store/store-context";
import { selectors } from "../store/state-selectors";
export function useManageLocationStack(_ref) {
  let {
    initialLocations
  } = _ref;
  const history = useHistory();
  const {
    setLocationStack
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  useOnMount(() => {
    setLocationStack(initialLocations);
    history.listen((location, action) => {
      const currentLocationStack = selectors.locationStack(getState());
      switch (action) {
        case 'PUSH':
          setLocationStack([...currentLocationStack, location]);
          break;
        case 'REPLACE':
          setLocationStack([...currentLocationStack.slice(0, -1), location]);
          break;
        case 'POP':
          setLocationStack(currentLocationStack.slice(0, -1));
          break;
      }
    });
  });
}